const images = {
  logo: require("../assets/images/pharmaace-logo-black.png"),
  avt: require("../assets/images/avatar.jpg"),
  logKey: require("../assets/images/Reset password-pana.svg"),
  dashboard: require("../assets/images/Revenue-cuate.svg"),
  notFound: require("../assets/images/Oops 404 Error with a broken robot-cuate.svg"),
  logoIcon: require("../assets/images/pace-logo-fav-icon.svg"),
};

export default images;
